// extracted by mini-css-extract-plugin
export default {"container":"style_container__4w3K3","iconCol":"style_iconCol__uuZxD"};